module.exports = __webpack_public_path__ + "static/media/logoBlueShield.d0047592.png";